import React, { useEffect } from 'react';

const AboutHero = () => {
  useEffect(() => {
    // Hero başlığı için animasyon
    const title = document.querySelector('.hero-title');
    if (title) {
      title.classList.add('animate-fadeInUp');
    }
    
    // Hero açıklaması için animasyon (gecikmeli)
    const description = document.querySelector('.hero-description');
    if (description) {
      setTimeout(() => {
        description.classList.add('animate-fadeInUp');
      }, 300);
    }
    
    // Arka plan müzik notaları animasyonu
    const createMusicNotes = () => {
      const container = document.querySelector('.music-notes-container');
      if (!container) return;
      
      for (let i = 0; i < 20; i++) {
        const note = document.createElement('div');
        const size = Math.random() * 20 + 10; // 10-30px arası
        const position = Math.random() * 100; // 0-100% arası
        const delay = Math.random() * 5; // 0-5s arası
        const duration = Math.random() * 10 + 10; // 10-20s arası
        
        note.className = 'absolute opacity-0 text-white';
        note.style.fontSize = `${size}px`;
        note.style.left = `${position}%`;
        note.style.top = '-50px';
        note.style.animation = `floatUp ${duration}s linear ${delay}s infinite`;
        
        // Müzik sembollerini rastgele seç
        const symbols = ['♪', '♫', '♬', '♩', '♭', '♮', '♯'];
        note.textContent = symbols[Math.floor(Math.random() * symbols.length)];
        
        container.appendChild(note);
      }
    };
    
    createMusicNotes();
    
    // Component unmount olduğunda temizle
    return () => {
      const container = document.querySelector('.music-notes-container');
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="relative overflow-hidden bg-indigo-600 pt-24 pb-20">
      {/* Animasyonlu müzik notaları için container */}
      <div className="music-notes-container absolute inset-0 overflow-hidden z-0" />
      
      {/* Gradient arka plan */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-700 via-indigo-600 to-purple-600" />
      
      {/* Animasyonlu dalga şekli */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
          <path 
            fill="#f8fafc" 
            fillOpacity="1" 
            d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,202.7C672,203,768,181,864,181.3C960,181,1056,203,1152,197.3C1248,192,1344,160,1392,144L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            className="animate-pulse"
            style={{animationDuration: '7s'}}
          ></path>
        </svg>
      </div>
      
      {/* İçerik */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <h1 className="hero-title opacity-0 text-5xl font-extrabold text-white sm:text-6xl sm:tracking-tight lg:text-7xl mb-6">
            Biz Kimiz?
          </h1>
          <p className="hero-description opacity-0 mt-6 text-xl text-indigo-100 max-w-prose mx-auto">
            İYTE Müzik Topluluğu kampüsümüzdeki müzik tutkunlarını bir araya getiriyor.
          </p>
          
          {/* Animasyonlu scroll-down işareti */}
          <div className="mt-16 animate-bounce">
            <svg className="mx-auto h-8 w-8 text-white opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </div>
        </div>
      </div>
      
      {/* Custom animasyonlar için stil */}
      <style jsx>{`
        @keyframes floatUp {
          0% {
            transform: translateY(0);
            opacity: 0;
          }
          10% {
            opacity: 0.7;
          }
          90% {
            opacity: 0.7;
          }
          100% {
            transform: translateY(-100vh);
            opacity: 0;
          }
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease forwards;
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default AboutHero;